interface Props {
  summary: string;
  strengths: string[];
  concerns: string[];
  tips: string[];
}

export default function NutritionTipsList({ summary, strengths, concerns, tips }: Props) {
  return (
    <div className="xpn-nutrition-tips">
      <p className="xpn-text-body-md xpn-text" style={{ marginBottom: 16, lineHeight: 1.6 }}>
        {summary}
      </p>

      {strengths.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <h4 style={{ color: "var(--xpn-color-success)", marginBottom: 8, fontSize: 13, fontWeight: 650, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            ✅ Strengths
          </h4>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {strengths.map((s, i) => (
              <li key={i} className="xpn-text-body-md xpn-text-muted" style={{ marginBottom: 4 }}>
                {s}
              </li>
            ))}
          </ul>
        </div>
      )}

      {concerns.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <h4 style={{ color: "var(--xpn-color-warning)", marginBottom: 8, fontSize: 13, fontWeight: 650, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            ⚠️ Areas to Watch
          </h4>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {concerns.map((c, i) => (
              <li key={i} className="xpn-text-body-md xpn-text-muted" style={{ marginBottom: 4 }}>
                {c}
              </li>
            ))}
          </ul>
        </div>
      )}

      {tips.length > 0 && (
        <div>
          <h4 style={{ color: "var(--xpn-color-primary)", marginBottom: 8, fontSize: 13, fontWeight: 650, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            💡 Tips
          </h4>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {tips.map((tip, i) => (
              <div
                key={i}
                className="xpn-card"
                style={{ padding: "10px 14px", borderLeft: "3px solid var(--xpn-color-primary)" }}
              >
                <div className="xpn-text-body-md xpn-text">{tip}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
